export default "__VITE_ASSET__BnquQAjO__"